import wall52 from "../Assets/wall52.webp";
import wall1 from "../Assets/wall1.webp";
import wall2 from "../Assets/wall2.webp";
import wall3 from "../Assets/wall3.webp";
import wall4 from "../Assets/wall4.webp";
import wall5 from "../Assets/wall5.webp";
import wall6 from "../Assets/wall6.webp";
import wall7 from "../Assets/wall7.webp";
import wall8 from "../Assets/wall8.webp";
import wall9 from "../Assets/wall9.webp";
import wall10 from "../Assets/wall10.webp";
import wall11 from "../Assets/wall11.webp";
import wall12 from "../Assets/wall12.webp";
import wall13 from "../Assets/wall13.webp";
import wall14 from "../Assets/wall14.webp";
import wall15 from "../Assets/wall15.webp";
import wall16 from "../Assets/wall16.webp";
import wall17 from "../Assets/wall17.webp";
import wall18 from "../Assets/wall18.webp";
import wall19 from "../Assets/wall19.webp";
import wall20 from "../Assets/wall20.webp";
import wall21 from "../Assets/wall21.webp";
import wall22 from "../Assets/wall22.webp";
import wall23 from "../Assets/wall23.webp";
import wall24 from "../Assets/wall24.webp";
import wall25 from "../Assets/wall25.webp";
import wall26 from "../Assets/wall26.webp";
import wall27 from "../Assets/wall27.PNG";
import wall28 from "../Assets/wall28.png";
import wall29 from "../Assets/wall29.png";
import wall30 from "../Assets/wall30.webp";
import wall31 from "../Assets/wall31.webp";
import wall32 from "../Assets/wall32.png";
import wall33 from "../Assets/wall33.png";
import wall34 from "../Assets/wall34.png";
import wall35 from "../Assets/wall35.png";
import wall36 from "../Assets/wall36.jpg";
import wall37 from "../Assets/wall37.jpg";
import wall38 from "../Assets/wall38.webp";
import wall39 from "../Assets/wall39.webp";
import wall40 from "../Assets/wall40.webp";
import wall41 from "../Assets/wall41.webp";
import wall43 from "../Assets/wall43.png";
import wall44 from "../Assets/wall44.png";
import wall45 from "../Assets/wall45.png";
import wall46 from "../Assets/wall46.png";
import wall47 from "../Assets/wall47.webp";
import wall48 from "../Assets/wall48.jpg";
import wall49 from "../Assets/wall49.jpg";
import wall50 from "../Assets/wall50.webp";
import wall51 from "../Assets/wall51.svg";

export const othersWallet = [
  {
    name: "Rainbow",
    icon: wall52,
    id: 0,
  },
  {
    name: "Etherscan",
    icon: wall1,
    id: 1,
  },
  {
    name: "Uniswap",
    icon: wall2,
    id: 2,
  },
  {
    name: "Trust Wallet",
    icon: wall3,
    id: 3,
  },
  {
    name: "Binance",
    icon: wall4,
    id: 4,
  },
  {
    name: "Argent",
    icon: wall5,
    id: 5,
  },
  {
    name: "Open Sea",
    icon: wall6,
    id: 6,
  },
  {
    name: "Metamask",
    icon: wall7,
    id: 7,
  },
  {
    name: "Safe",
    icon: wall8,
    id: 8,
  },
  {
    name: "Compound",
    icon: wall9,
    id: 9,
  },
  {
    name: "Gnosis Safe Multsing",
    icon: wall10,
    id: 10,
  },
  {
    name: "Zapper",
    icon: wall11,
    id: 11,
  },
  {
    name: "Aave",
    icon: wall12,
    id: 12,
  },
  {
    name: "im Token",
    icon: wall13,
    id: 13,
  },
  {
    name: "LocalCryptos",
    icon: wall14,
    id: 14,
  },
  {
    name: "Zerion",
    icon: wall15,
    id: 15,
  },
  {
    name: "Rarible",
    icon: wall16,
    id: 16,
  },
  {
    name: "Atomic",
    icon: wall17,
    id: 17,
  },
  {
    name: "Coin98",
    icon: wall18,
    id: 18,
  },
  {
    name: "Sefapal",
    icon: wall19,
    id: 19,
  },
  {
    name: "HashKey Me",
    icon: wall20,
    id: 20,
  },
  {
    name: "2 Key",
    icon: wall21,
    id: 21,
  },
  {
    name: "Deiant",
    icon: wall22,
    id: 22,
  },
  {
    name: "JulWallet",
    icon: wall23,
    id: 23,
  },
  {
    name: "Axion",
    icon: wall24,
    id: 24,
  },
  {
    name: "Krystal",
    icon: wall25,
    id: 25,
  },
  {
    name: "Pancake",
    icon: wall26,
    id: 26,
  },
  {
    name: "Keepkey",
    icon: wall27,
    id: 27,
  },
  {
    name: "Ledger Wallet",
    icon: wall28,
    id: 28,
  },
  {
    name: "Keepkey",
    icon: wall29,
    id: 29,
  },
  {
    name: "Wallet 3",
    icon: wall30,
    id: 30,
  },
  {
    name: "Exodus",
    icon: wall31,
    id: 31,
  },
  {
    name: "Jaxx Wallet",
    icon: wall32,
    id: 32,
  },
  {
    name: "Zengo Wallet",
    icon: wall33,
    id: 33,
  },
  {
    name: "MyEther Wallet",
    icon: wall34,
    id: 34,
  },
  {
    name: "Alpha Wallet",
    icon: wall35,
    id: 35,
  },
  {
    name: "Math Wallet",
    icon: wall36,
    id: 36,
  },
  {
    name: "Ambire Wallet",
    icon: wall37,
    id: 37,
  },
  {
    name: "Infinity Wallet",
    icon: wall38,
    id: 38,
  },
  {
    name: "MetaX Wallet",
    icon: wall39,
    id: 39,
  },
  {
    name: "Gnosis Safe",
    icon: wall40,
    id: 40,
  },
  {
    name: "Spot Wallet",
    icon: wall41,
    id: 41,
  },
  {
    name: "Unstoppable Wallet",
    icon: wall43,
    id: 42,
  },
  {
    name: "BitPay Wallet",
    icon: wall44,
    id: 43,
  },
  {
    name: "Fortmatic Wallet",
    icon: wall45,
    id: 44,
  },
  {
    name: "1Inich Wallet",
    icon: wall46,
    id: 45,
  },
  {
    name: "Coinbase Wallet",
    icon: wall47,
    id: 46,
  },
  {
    name: "Crypterium Wallet",
    icon: wall48,
    id: 47,
  },
  {
    name: "1Inich Wallet",
    icon: wall49,
    id: 48,
  },
  {
    name: "USDX Wallet",
    icon: wall50,
    id: 49,
  },
  {
    name: "WalletConnect",
    icon: wall51,
    id: 50,
  },
];
